import { useNavigate, useLocation } from "react-router-dom";
import { useRemanso } from "@/context/RemansoContext";
import { promptInstall, usePwa } from "@/lib/pwa";

const hasText = (e) => !!(e.title?.trim() || e.body?.trim());

// small paper card above the entry list; only with an empty sheet, never while writing
export const InstallCard = ({ entries, prefix, onNavigate }) => {
  const navigate = useNavigate();
  const onSheet = useLocation().pathname.startsWith("/escribir");
  const { settings, dismissInstall, draftEmpty } = useRemanso();
  const { installed } = usePwa();
  if (!settings || installed || (onSheet && !draftEmpty)) return null;
  if ((settings.install_dismissals || 0) >= 2) return null;
  if (settings.install_hidden_until && new Date(settings.install_hidden_until) > new Date()) return null;
  if (entries.filter(hasText).length < 2) return null;

  const see = async () => {
    if (await promptInstall()) return;
    onNavigate?.();
    navigate("/instalar");
  };
  return (
    <div className="rounded-[16px] border border-linea bg-papel px-3.5 py-3" data-testid={`${prefix}-install-card`}>
      <p className="text-[13px] text-sec leading-snug">¿Quieres tener Pensive a un toque? Puedes instalarla en tu pantalla de inicio.</p>
      <div className="mt-2 flex items-center gap-1 -ml-2">
        <button type="button" className="btn-text text-[13px]" onClick={see} data-testid={`${prefix}-install-card-see`}>Ver cómo</button>
        <button type="button" className="btn-text text-[13px] text-meta" onClick={() => dismissInstall().catch(() => {})} data-testid={`${prefix}-install-card-later`}>Ahora no</button>
      </div>
    </div>
  );
};
